<script>
export default {
	name: 'BoardHeader'
}
</script>

<template lang="html">
	<header class="board-header" role="banner" aria-label="Header dashboard">
		<h1 class="dashboard-title">Tableau de bord</h1>
		<span class="dashboard-subtitle">Gérez vos prospects et suivez vos clients.</span>
	</header>
</template>

<style scoped>
	.board-header {
		width: 100%;
		padding: 1rem 0;
		margin: 1rem 0;
	}
</style>


// WEBPACK FOOTER //
// BoardHeader.vue?5229a040